/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskForm990 } from './ExecRiskForm990';
import {
    ExecRiskForm990FromJSON,
    ExecRiskForm990FromJSONTyped,
    ExecRiskForm990ToJSON,
} from './ExecRiskForm990';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedEagerForm990Response
 */
export interface ExecRiskPaginatedEagerForm990Response {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedEagerForm990Response
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskForm990>}
     * @memberof ExecRiskPaginatedEagerForm990Response
     */
    results: Array<ExecRiskForm990>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedEagerForm990Response
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedEagerForm990Response
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedEagerForm990Response
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedEagerForm990Response interface.
 */
export function instanceOfExecRiskPaginatedEagerForm990Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedEagerForm990ResponseFromJSON(json: any): ExecRiskPaginatedEagerForm990Response {
    return ExecRiskPaginatedEagerForm990ResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedEagerForm990ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedEagerForm990Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskForm990FromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedEagerForm990ResponseToJSON(value?: ExecRiskPaginatedEagerForm990Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskForm990ToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

